<script setup>
import { useTestRenderStore } from '@stores';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

const renderStore = useTestRenderStore();
const { t } = useI18n({ useScope: 'global' });

const { question, questionsInfo, currentQuestionId } = storeToRefs(renderStore);
const selectQuestion = async (id) => {
    await renderStore.getExamQuestion(id);
};
</script>

<template>
    <div class="render-top">
        <Button :label="t('tests.previous')" icon="pi pi-angle-left" @click="renderStore.goToPreviousQuestion" :disabled="questionsInfo[0]?.id === currentQuestionId" />
        <div class="questions-navigation">
            <Button v-for="(data, index) in questionsInfo" :key="data.id" :label="`${index + 1}`" :severity="data.checked ? 'info' : data.isCorrect === true ? 'success' : data.isCorrect === false ? 'danger' : ''" :variant="currentQuestionId !== data.id ? 'outlined' : ''" @click="selectQuestion(data.id)" class="navigation-btn" />
            <!-- :severity="data.checked ? 'info' : data.isCorrect ? 'success' : 'danger'"  -->
        </div>

        <Button icon="pi pi-angle-right" :label="t('tests.next')" iconPos="right" @click="renderStore.goToNextQuestion" :disabled="questionsInfo[questionsInfo.length - 1]?.id === currentQuestionId" />
    </div>
</template>

<style scoped>
.render-top {
    @apply flex items-center justify-between w-full;
}
.questions-navigation {
    @apply flex flex-wrap gap-2 items-center justify-center;
}
.navigation-btn {
    @apply w-10 h-10 flex items-center justify-center;
}

/* Mobile adaptations */
@media (max-width: 768px) {
    .render-top {
        @apply flex-col gap-3;
    }

    .questions-navigation {
        @apply gap-1.5 max-w-full overflow-x-auto px-2;
    }

    .navigation-btn {
        @apply w-9 h-9 text-sm;
        min-width: 36px;
    }
}

@media (max-width: 480px) {
    .render-top {
        @apply gap-2;
    }

    .questions-navigation {
        @apply gap-1;
    }

    .navigation-btn {
        @apply w-8 h-8 text-xs;
        min-width: 32px;
    }
}
</style>
